import {
  isMallIOS,
  isMallAndroid,
  isMCMallCirculationAndroid,
  isMCMallCirculationIOS,
  isMCMallKeyCustomerIOS,
  isMCMallKeyCustomerAndroid
} from '@mc/mc-base-env/src/web/platform.js'
import Url from '@mc/mc-utils/js/url/url'

export const getAppKey = (appInfo, miniProgramEnv) => {
  const url = new Url(window.location.href)
  const query = url.parseQuerystring()
  const hashQuery = url.Hash ? url.Hash.parseQuerystring() : {}
  if (
    isMallIOS() ||
    isMallAndroid() ||
    isMCMallCirculationIOS() ||
    isMCMallCirculationAndroid() ||
    isMCMallKeyCustomerIOS() ||
    isMCMallKeyCustomerAndroid()
  ) {
    return appInfo.app_key || 'mall'
  }
  if (miniProgramEnv.isMiniProgram) {
    return (
      query.app_key ||
      hashQuery.app_key ||
      query.appKey ||
      hashQuery.appKey ||
      'mall'
    )
  }
  return (
    query.app_key ||
    hashQuery.app_key ||
    query.appKey ||
    hashQuery.appKey ||
    'mall'
  )
}
